// extracted by mini-css-extract-plugin
module.exports = {"BooksLoading":"BooksLoading_BooksLoading__C4_Tq","BooksLoading_Icon":"BooksLoading_BooksLoading_Icon__fKIJ2"};